/**
 * Creates a memory efficient rotating, auto-evicting array.
 * Useful for tracking specific statuses etc. change over time for reporting
 * when an event occurs.
 */
export const createRingBuffer = <T>(size: number) => {
  let pointer = 0;
  let length = 0;
  let buffer: T[] = new Array(size);

  return {
    /** The total pre-allocated capacity of the buffer. */
    get size() {
      return size;
    },
    /** The current count of items filled in the buffer. */
    get length() {
      return length;
    },
    /** Push a new item into the buffer. */
    push: (item: T) => {
      buffer[pointer] = item;
      pointer = (pointer + 1) % size;
      length = Math.min(length + 1, size);
      return item;
    },
    /** Convert the buffer into an array (in order added). */
    toArray: () => {
      const orderedArray = [
        ...buffer.slice(pointer),
        ...buffer.slice(0, pointer),
      ];
      // Trim if buffer is not full.
      return size === length ? orderedArray : orderedArray.slice(size - length);
    },
    /** Clear the array buffer. */
    clear: () => {
      pointer = 0;
      length = 0;
      buffer = new Array(size);
    },
  };
};
